import { STATES } from '~/utils';
import { WorksheetField } from '../../../worksheets/common/components/Field';
import WorksheetForm from '~/features/projectWizard/worksheets/common/components/WorksheetForm';
import { useDerivedRECFields } from '~/features/projectWizard/derived';

export default function Location() {
  // Updates REC data based on addressState changes
  useDerivedRECFields();

  return (
    <WorksheetForm>
      <WorksheetField
        schemaKey="addressStreet"
        placeholder="Enter address"
        fieldLabel='Address'
      />
      <WorksheetField.Row>
        <WorksheetField
          schemaKey="addressCity"
          fluid
          placeholder="Enter city"
          fieldLabel='City'
          width="half"
        />
        <WorksheetField
          schemaKey="addressState"
          search
          options={STATES}
          placeholder="Select state"
          fieldLabel='State'
          width="half"
        />
      </WorksheetField.Row>
      <WorksheetField.Row>
        <WorksheetField
          schemaKey="addressZip"
          placeholder="Enter zip code"
          fieldLabel='Zip Code'
          width="half"
        />
        <WorksheetField
          schemaKey="utilityZone"
          placeholder="Enter name of electric utility"
          fieldLabel="Electric utility"
          maxLength={250}
          width="half"
        />
      </WorksheetField.Row>
    </WorksheetForm>
  );
}